var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-teacher-enroll-audit" },
    [
      _c("xxbiz-signup", {
        attrs: { mod: "info", id: _vm.aduitId },
        on: { callback: _vm.callback },
      }),
      _c("div", { staticClass: "standard-size-16 color-gray-10" }, [
        _c(
          "div",
          { staticClass: "mb32 font-bolder" },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t(
                    "pc_biz_te_lbl_authentication_information" /* 认证信息 */
                  )
                ) +
                "\n      "
            ),
            _c(
              "yxtf-row",
              {
                staticClass: "mv24 font-normal font-size-14",
                attrs: { type: "flex" },
              },
              [
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pc_biz_te_lbl_authentication_name" /* 认证名称 */
                          )
                        ) + "："
                      ),
                    ]),
                    _c(
                      "yxtf-tooltip",
                      {
                        attrs: {
                          "open-filter": true,
                          content: _vm.info.authenticationName,
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "yxtbiz-teacher-enroll-audit_ellipsis",
                          },
                          [_vm._v(_vm._s(_vm.info.authenticationName))]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pc_biz_te_lbl_authentication_time" /* 认证时间 */
                          )
                        ) + "："
                      ),
                    ]),
                    _c(
                      "yxtf-tooltip",
                      { attrs: { "open-filter": true, placement: "top" } },
                      [
                        _vm.info.authenticationStartTime &&
                        _vm.info.authenticationEndTime
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "yxtbiz-teacher-enroll-audit_ellipsis",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.info.authenticationStartTime) +
                                    " " +
                                    _vm._s(
                                      _vm.$t("pc_biz_te_lbl_to" /* 至 */)
                                    ) +
                                    " " +
                                    _vm._s(_vm.info.authenticationEndTime)
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _vm._v(
                              _vm._s(_vm.info.authenticationStartTime) +
                                _vm._s(_vm.$t("pc_biz_te_lbl_to" /* 至 */)) +
                                _vm._s(_vm.info.authenticationEndTime)
                            ),
                          ]
                        ),
                      ]
                    ),
                    !_vm.info.authenticationStartTime &&
                    !_vm.info.authenticationEndTime
                      ? _c("span", [_vm._v("--")])
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "yxtf-row",
              {
                staticClass: "font-normal font-size-14",
                attrs: { type: "flex" },
              },
              [
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pc_biz_te_lbl_authentication_type" /* 认证类型 */
                          )
                        ) + "："
                      ),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.info && _vm.info.targetType
                            ? _vm
                                .$t("pc_biz_lbl_certtype_course")
                                .d("课程授权认证")
                            : _vm
                                .$t("pc_biz_lbl_certtype_lecturer")
                                .d("讲师级别认证")
                        )
                      ),
                    ]),
                  ]
                ),
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm
                            .$t(
                              "pc_biz_tit_authentication_detail" /* 认证详情 */
                            )
                            .d("认证详情")
                        ) + "："
                      ),
                    ]),
                    _c(
                      "yxtf-tooltip",
                      {
                        staticClass: "yxtbiz-teacher-enroll-audit_ellipsis",
                        attrs: {
                          "open-filter": true,
                          placement: "top",
                          content: _vm.authDetail,
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.authDetail))])]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "font-bolder" },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("pc_biz_te_lbl_teaching_information" /* 教学信息 */)
                ) +
                "\n      "
            ),
            _c(
              "yxtf-row",
              {
                staticClass: "mv24 font-normal font-size-14",
                attrs: { type: "flex" },
              },
              [
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pc_biz_te_lbl_teaching_identity" /* 教学身份 */
                          )
                        ) + "："
                      ),
                    ]),
                    _vm.teachingObj.levelName
                      ? _c(
                          "yxtf-tooltip",
                          {
                            attrs: {
                              "open-filter": true,
                              content: _vm.teachingObj.levelName,
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "yxtbiz-teacher-enroll-audit_ellipsis",
                              },
                              [_vm._v(_vm._s(_vm.teachingObj.levelName))]
                            ),
                          ]
                        )
                      : _c("div", [
                          _vm._v(_vm._s(_vm.$t("pc_biz_te_lbl_no" /* 无 */))),
                        ]),
                  ],
                  1
                ),
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pc_biz_te_lbl_teaching_sessions" /* 面授场次 */
                          )
                        ) + "："
                      ),
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.teachingObj.faceCourseCount || "--")),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "yxtf-row",
              {
                staticClass: "font-normal font-size-14",
                attrs: { type: "flex" },
              },
              [
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("pc_biz_te_lbl_live_identity" /* 直播场次 */)
                        ) + "："
                      ),
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.teachingObj.liveCourseCount || "--")),
                    ]),
                  ]
                ),
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pc_biz_te_lbl_face_courseLength" /* 面授时长 */
                          )
                        ) + "："
                      ),
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.teachingObj.faceCourseLength || "--")),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "yxtf-row",
              {
                staticClass: "mv24 font-normal font-size-14",
                attrs: { type: "flex" },
              },
              [
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pc_biz_te_lbl_live_courseLength" /* 直播时长 */
                          )
                        ) + "："
                      ),
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.teachingObj.liveCourseLength || "--")),
                    ]),
                  ]
                ),
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pc_biz_te_lbl_face_satisfaction" /* 面授满意度 */
                          )
                        ) + "："
                      ),
                    ]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.teachingObj.faceSatisfaction || "--")),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }